import { useState, useEffect } from "react";
import classnames from "classnames";
import { useTicker } from "modules/dateTime";
import useStyles from "./styles";

const SoundWavesAnimation = (): JSX.Element => {
  const [random, setRandom] = useState(Math.random());

  const ticker = useTicker(true, 2500);
  useEffect(() => setRandom(Math.random), [ticker]);

  const random1 = random;
  const random2 = Math.random();
  const random3 = Math.random();

  const styles = useStyles({
    random1,
    random2,
    random3,
  });

  const innerCircles = [styles.small, styles.medium, styles.large].map(
    (className) => (
      <div key={className} className={classnames(styles.wave, className)} />
    ),
  );

  return (
    <div data-testid="sound-wave-animation" className={styles.root}>
      {innerCircles}
    </div>
  );
};

export default SoundWavesAnimation;
